import { Modal } from "antd";
import { freePlanDiscontinuedState, memberState } from "../state/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import "./FreePlanDiscontinuedModal.scss";
import DesignPlanSummary from "./DesignPlanSummary";
import { Button } from "./account/misc/Button";
import { logout } from "../service/AuthService";
import { env } from "../env/env";

export default function FreePlanDiscontinuedModal() {
  const [showFreePlanDiscontinued, setShowFreePlanDiscontinued] = useRecoilState(freePlanDiscontinuedState);
  const member = useRecoilValue(memberState);

  function onSubscribeNow() {
    if (!member || !member.id) return;
    setShowFreePlanDiscontinued(false);
    window.MHM.ProModal.upgradeToDesign({
      memberId: member.id,
      onSuccess: () => window.location.reload(),
      onDismiss: () => {
        logout().then(() => {
          window.location.href = env.basePath;
        });
      }
    });
  }

  return <Modal className={"free-plan-discontinued-modal clean"} open={showFreePlanDiscontinued} footer={null}>
    <header>
      <h1>We invite you to access your menus with our base-level Design Plan.</h1>
    </header>
    <DesignPlanSummary/>
    <footer>
      <Button size={"Large"} className={'primary design'} onClick={onSubscribeNow}>Subscribe Now</Button>
    </footer>
  </Modal>;
}
